import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';

const ClosingPage = ({ background, user, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>{user?.name || 'Despedida'}</h3>
          <p className='justified'>
            En este informe pudiste conocer tus preferencias vocacionales,
            explorar áreas de conocimiento y carreras que se conectan con tus
            intereses, y reflexionar sobre cómo estás enfrentando tu proceso de
            decisión. Pero este no es un punto final: es una invitación a seguir
            explorando, conversar con otras personas, investigar nuevas opciones
            y observar qué te atrae y por qué.
          </p>
          <p className='justified'>
            Te recordamos que llegar a una decisión vocacional no es algo que
            ocurra de un momento a otro. Es un proceso que se construye paso a
            paso, conociéndote mejor, reuniendo información y aprendiendo a
            tomar decisiones con mayor confianza.
          </p>
          <p className='justified'>
            La meta no está en encontrar “la carrera perfecta”, sino en
            desarrollar la seguridad, la autonomía y las herramientas necesarias
            para tomar decisiones informadas, y sentirte capaz de ajustar tu
            camino cuando sea necesario.{' '}
            <strong>
              Porque a lo largo de tu vida seguirás tomando decisiones
              importantes, y cada una de ellas será una nueva oportunidad para
              crecer y avanzar hacia lo que quieres construir.
            </strong>
          </p>
          <br />
          <p className='text-center'>
            <strong>¡Te deseamos mucho éxito en lo que viene!</strong>
          </p>
          <p className='text-center'>Equipo Edumetrics</p>

          <br />
          <br />
          <br />
          <br />
          <br />

          <div className='text-center'>
            <p>
              También puedes visitar el siguiente QR para revisar tus resultados
              online:
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              marginTop: 16

              // width: '100%'
              // display: 'flex',
              // justifyContent: 'center'
            }}
          >
            <img
              src={`https://www.edumetrics.cl/api/qr?url=https://www.edumetrics.cl/report/${user?.responseId}?k=${user?.responseAccessKey}`}
              alt='qr code'
              style={{
                width: 100,
                height: 100,
                display: 'block'
              }}
            />
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default ClosingPage;
